import NetworkLogic from "../../Shared/NetworkLogic";
import Constant from "../../Shared/Constant";
import AudioManager from "../../Shared/AudioManager";
import PopWindowManager from "../../Shared/PopWindowManager";
import Utils from "../../Shared/Utils";
import EnterSoundManager from "../../Shared/EnterSoundManager";
const {ccclass, property} = cc._decorator;

@ccclass
export default class TuiGuangLayer extends cc.Component {

    @property(cc.ToggleContainer)
    togC: cc.ToggleContainer = null;
    @property(cc.Node)
    myAgent: cc.Node = null;
    @property(cc.Node)
    playerCheck: cc.Node = null;
    @property(cc.Node)
    scoreCheck: cc.Node = null;
    @property(cc.Node)
    agentRecruit: cc.Node = null;
    @property(cc.Node)
    introduce: cc.Node = null;
    @property(cc.Node)
    treasure: cc.Node = null;
    @property(cc.Node)
    share: cc.Node = null;
    @property(cc.Toggle)
    togMyAgent: cc.Toggle = null;

    private _curLayer = null;
    private _type2Layer = null;

    jumpBindWechat = false;
    onLoad () {
        this.node.getChildByName("ScoreDetails").active  = false;
        this.node.getChildByName("commitData").active  = false;
        Utils.hideGameNode();

    }

    start () {

    }

    updateUI(skipData?){
        EnterSoundManager.playSound("enter_tuiguang");
        this._type2Layer = {
            myAgent:this.myAgent,
            playerCheck:this.playerCheck,
            scoreCheck:this.scoreCheck,
            agentRecruit: this.agentRecruit,
            introduce:this.introduce,
            treasure:this.treasure,
            share:this.share
        };

        if (skipData){
            for (let i = 0;i < this.togC.toggleItems.length;i++){
                let tog = this.togC.toggleItems[i];
                if (tog.node.name === skipData){
                    tog.check();
                    break;
                }
            }
        }else{
            this.onToggleSelected(null,"myAgent",false);
        }

    }

    onEnable(): void {
        this.node.getComponent(cc.Animation).play("enter_tuiguang");
    }

    onBtnClick(event,param){
        AudioManager.playSound("close");
        if (param === "back"){
            AudioManager.playSound("close");
            PopWindowManager.openNext();
            Utils.showGameNode();
            this.node.destroy();
        }
    }

    onToggleSelected(event,param,playSound = true){
        playSound && AudioManager.playSound("toggle");
        for (let key in this._type2Layer){
            this._type2Layer[key].active = false;
        }
        this._curLayer && (this._curLayer.active = false);
        this._curLayer = this._type2Layer[param];
        this._curLayer.active = true
    }
}
